import(/* webpackMode: "eager" */ "/ibznts/src/app/solution/lms/page.tsx");
